import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useClassName } from 'common/hooks';
import { inject } from 'mobx-react';
import {
  getContentfulField,
  getContentfulAssetUrlandAlt,
} from 'common/components';
import { Dimmer, Loader } from 'semantic-ui-react';
import { LoaderImage } from 'public/components/Loader';
import './map.less';

const Map = ({ venues }) => {
  const [loading, setLoading] = useState(false);
  const [mapImage, setMapImage] = useState(null);
  const className = useClassName('VenueMap');
  const { slug } = useParams();
  const history = useHistory();

  const getVenueDetails = async () => {
    try {
      setLoading(true);
      const venue = await venues.fetchItemBySlug(slug);
      const infoBlocks = getContentfulField(venue.content.infoBlocks).filter(
        (ib) => !!ib.fields.extraImage
      );
      const infoBlock = infoBlocks.find(
        (infoBlock) =>
          getContentfulAssetUrlandAlt(infoBlock.fields.extraImage)?.assetAlt ===
          'map'
      );
      if (!infoBlock) return history.push(`/venue/${slug}`);
      if (infoBlock) {
        const extraImage = getContentfulAssetUrlandAlt(
          infoBlock.fields.extraImage
        );
        if (!extraImage) return history.push(`venue/${slug}`);
        setMapImage(extraImage);
      }
    } catch (e) {
      history.push(`venue/${slug}`);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getVenueDetails();
  }, []);

  if (loading) {
    return (
      <Dimmer active inverted>
        <Loader>Loading</Loader>
      </Dimmer>
    );
  }

  return (
    <div className={className('container')}>
      <LoaderImage
        className={className('map-image')}
        src={mapImage?.assetUrl}
        alt={mapImage?.assetAlt}
        loadingHeight={20}
        hideLoader
      />
    </div>
  );
};

export default inject('venues')(Map);
